import { Group } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';
import Text from '@ui/components/Text/Text';
import { Link } from '@material-ui/core';

const LearnMoreLink = () => (
	<Link href="https://support.verybusy.io/en/articles/9650222-roles-within-verybusy-io#h_c08e6478ea" target="_blank">
		<Group spacing={4}>
			<Icon icon="info_outlined" size={14} color="black" />
			<Text variant="footnote" color="black">Learn about roles and permissions</Text>
		</Group>
	</Link>
);

export default LearnMoreLink;
